export default {
  home: 'Home',
  menu: 'Menu',
  orders: 'Bestellingen',
};
